import { render, staticRenderFns } from "./headerY.vue?vue&type=template&id=e9841efa&scoped=true&"
import script from "./headerY.vue?vue&type=script&lang=js&"
export * from "./headerY.vue?vue&type=script&lang=js&"
import style0 from "./headerY.vue?vue&type=style&index=0&id=e9841efa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9841efa",
  null
  
)

export default component.exports